import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import http from '@/plugins/http'
import Socket from '@/plugins/socket'

import VueCompositionAPI from "@vue/composition-api"
Vue.use(VueCompositionAPI);

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/scss/app.scss';
import './assets/scss/ProgressBarWars.scss'
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faCoffee, fas, far, fab);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.prototype.$http = http;
Vue.prototype.$socket = new Socket(`https://${process.env.HOST}:8888/marks`);

//  Vueで検知できるキーコードを追加
Vue.config.keyCodes = {
  b1: 49, //  「1」
  b2: 50, //  「2」
  b3: 51, //  「3」
  b4: 52, //  「4」
  b5: 53, //  「5」
  b6: 54, //  「6」
  b7: 55, //  「7」
  b8: 56, //  「8」
  b9: 57  //  「9」
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
